import {
  CarouselVisiblePayload,
  ClickCarouselLinkPayload,
  NavigateCarouselPayload,
} from '@noths/polaris-client-ribbons-design-system';
import { createAction } from '@reduxjs/toolkit';

export const clickCarouselLink = createAction<ClickCarouselLinkPayload>(
  'linkCarousel/clickCarouselLink',
);

export const navigateCarousel = createAction<NavigateCarouselPayload>(
  'linkCarousel/navigateCarousel',
);

export const carouselVisible = createAction<CarouselVisiblePayload>('linkCarousel/carouselVisible');
